import type React from "react";
import type { ButtonProps } from "@material-ui/core";
import { Button as MuiButton } from "@material-ui/core";
import { createStyles, withStyles } from "@material-ui/core/styles";

import type { CoretexTheme } from "../theme";

const styles = (theme: CoretexTheme) => ({
  root: {
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1.5, 3),
  },
  label: {
    fontSize: "12px",
    letterSpacing: "1.25px",
  },
  text: {
    color: theme.palette.colour.primaryBlue,
  },
  textSecondary: {
    color: theme.palette.mono.secondaryDark,
  },
  contained: {
    backgroundColor: theme.palette.colour.primaryBlue,
    "&:hover": {
      backgroundColor: theme.palette.mono.primaryDark,
      color: theme.palette.mono.white,
    },
    color: theme.palette.mono.white,
  },
  containedSecondary: {
    background: "none",
    border: `1px solid ${theme.palette.colour.primaryBlue}`,
    color: theme.palette.colour.primaryBlue,
    "&:hover": {
      border: `1px solid ${theme.palette.mono.primaryDark}`,
      color: theme.palette.mono.primaryDark,
      background: "none",
    },
  },
  disabled: {
    backgroundColor: theme.palette.mono.mediumGray,
    color: theme.palette.mono.secondaryDark,
  },
});

// @ts-expect-error TS(2322) FIXME: Type 'ComponentType<Pick<{ children?: ReactNode; c... Remove this comment to see the full error message
const Button: React.ComponentType<ButtonProps> = withStyles(createStyles(styles))(MuiButton);

export default Button;
